module.exports = require('./helpers/bundle-url').getBundleURL('8kqgc') + "Plus.a3382127.png";